/*
 * Isotipo: el simbolo solo, sin el nombre.
 *
 * Generado desde los archivos de marca de `frontend/public`; las coordenadas
 * no se transcribieron a mano.
 *
 * Dos decisiones que conviene no deshacer:
 *
 * **El dibujo se colorea con `currentColor`, no con un color fijo.** Asi la
 * marca hereda el color del texto que la rodea y sirve igual sobre el marino
 * del panel del chofer que sobre el blanco del contenido. El archivo
 * `LOGO WHITE.svg` no valia para eso: solo cambia a blanco el texto y deja el
 * isotipo en marino, de modo que sobre fondo marino desaparece la mitad del
 * dibujo.
 *
 * **El ambar se queda fijo.** Es el acento de la identidad y tiene contraste
 * suficiente contra el marino y contra el blanco; heredarlo lo perderia.
 *
 * El `viewBox` esta ajustado al contenido real. Los originales vienen en un
 * lienzo de 1080x1080 con el dibujo dentro, y usarlo tal cual dejaria margenes
 * enormes que hay que compensar a ojo en cada sitio donde se coloque.
 */
import type { ReactNode } from 'react';

interface BrandMarkProps {
  /** Clases del contenedor. El color se toma del texto heredado. */
  className?: string;
}

/**
 * Se usa donde no cabe el logotipo completo: el riel del panel, la cabecera
 * del chofer, el icono de la pestana.
 *
 * Es decorativo y va con `aria-hidden`: el nombre del sistema siempre esta
 * escrito al lado, y anunciarlo dos veces solo estorba a quien usa un lector
 * de pantalla.
 */
export function BrandMark({ className }: BrandMarkProps): ReactNode {
  return (
    <svg
      viewBox="221.3 196.4 622.6 714.4"
      role="presentation"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <polygon
        fill={'var(--color-accent)'}
        points="709.51 464.78 840.83 694.16 841.92 389 709.51 464.78"
      />
      <polygon
        fill={'currentColor'}
        points="224.5 386.78 223.33 715.79 508.84 552.29 224.5 386.78"
      />
      <polygon
        fill={'var(--color-accent)'}
        points="566.31 214.81 697.71 444.18 830.12 368.35 566.31 214.81"
      />
      <polygon
        fill={'currentColor'}
        points="236.46 366.26 532.67 538.64 677.06 456 529.5 198.4 236.46 366.26"
      />
      <polygon
        fill={'currentColor'}
        points="235.13 736.43 531.34 908.84 828.77 738.57 532.58 566.13 235.13 736.43"
      />
      <polygon
        fill={'currentColor'}
        points="556.42 552.46 820.15 705.98 688.85 476.58 556.42 552.46"
      />
    </svg>
  );
}
